import { ref } from 'vue';
import { Service, Traveller } from '../types';

const getSingleDefaultTravellerData = (): Traveller => {
    const { pickupPlaces } = window.RESERVATION_STORE;
    const selectedPickupPlace = pickupPlaces && pickupPlaces.length === 1 ? pickupPlaces[0] : undefined;

    return {
        first_name: '',
        last_name: '',
        birthdate: '',
        id_card: '',
        address_street: '',
        address_city: '',
        address_post_code: '',
        address_country: 'SK',
        pickup_place: selectedPickupPlace,
        services: {},
        // arrayOfServices: [],
        hash: '',
    };
};

const getDefaultTravellerData = (number: number) => {
    const output = [];

    for (let index = 0; index < number; index++) {
        output.push(getSingleDefaultTravellerData());
    }

    return output;
};

const getInitialTravellersData = (initialRequest = false) => {
    const reservationObject = window.RESERVATION_STORE.reservation;

    if (!reservationObject) {
        return [];
    }

    let output = JSON.parse(JSON.stringify(window.RESERVATION_STORE.reservation?.travellers ?? []));
    output = output.constructor === Array ? output : Object.values(output) as Traveller[];

    if (output.length > 0) {
        output.forEach((traveller: Traveller, index: number) => {
            output[index] = { ...getSingleDefaultTravellerData(), ...((traveller.constructor) === Object ? traveller : {}) };

            if (Array.isArray(output[index].services)) {
                output[index].services = {};
            }
        });
    }

    if (initialRequest) {
        output = [...output, ...getDefaultTravellerData(reservationObject.requested_travellers_count - output.length)];
    }

    return output;
};

const localTravellers = ref<Traveller[]>(getInitialTravellersData(true) ?? []);

export const useLocalTravellers = () => {
    const setLocalTravellers = (value: Traveller[]) => {
        localTravellers.value = value;
    };

    const selectServiceForLocalTraveller = (index: number, service: Service) => {
        localTravellers.value[index].services = {
            ...localTravellers.value[index].services,
            [service.internal_name]: service,
        } as Traveller['services'];
    };

    const deselectServiceForLocalTraveller = (index: number, serviceInternalName: string) => {
        const services = { ...localTravellers.value[index].services };

        delete services[serviceInternalName];

        localTravellers.value[index].services = services;
    };

    return {
        localTravellersRef: localTravellers,
        selectServiceForLocalTraveller,
        deselectServiceForLocalTraveller,
        setLocalTravellers,
        getSingleDefaultTravellerData,
        getDefaultTravellerData,
        getInitialTravellersData,
    };
};
